import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { Repository } from "../../adapters/repository";

function createInteractor(repository: Repository): Interactor {
  return ({ planzoneId, pageSize, pageIndex, logTypesFilter }) =>
    present(
      repository
        .getPlanzoneLogs(planzoneId, pageSize, pageIndex, logTypesFilter)
        .then((response) => ({
          logs: response.logs,
          planzoneId,
          pages: response.pages,
          logTypesFilter,
          pageIndex,
        }))
        .catch((error) => Promise.reject({ error, planzoneId })),
    );
}

export type { Interactor };

export { createInteractor };
